import { Graphics, Container, ContainerChild, Text, Sprite, Texture } from "pixi.js";
import QRCode from "qrcode";
import type { IStudioWidget } from "../../../../screens/Dashboard/SubComponents/Studio/interfaces/sub-interfaces/Widgets.interface";

export class QRWidgetRenderer {
  async render(
    widget: IStudioWidget,
    container: Container,
    destination: { x: number; y: number; width: number; height: number }
  ): Promise<void> {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const options = (widget as any).options || {};
    const backgroundColor = options.backgroundColor || "#ffffff";
    const foregroundColor = options.foregroundColor || options.qrColor || "#000000";
    const qrContent = options.content || options.urlOrText || "https://eriol.io";

    // Background
    const bg = new Graphics();
    bg.rect(0, 0, destination.width, destination.height).fill(backgroundColor);
    container.addChild(bg);

    try {
      // Generate QR code as data URL
      const qrDataUrl = await QRCode.toDataURL(qrContent, {
        width: Math.max(destination.width, destination.height), // Use max dimension to ensure quality when scaling down/stretching
        margin: 1,
        color: {
          dark: foregroundColor,
          light: backgroundColor,
        },
      });

      // Create image element and load the data URL
      const image = new Image();
      await new Promise<void>((resolve, reject) => {
        image.onload = () => resolve();
        image.onerror = reject;
        image.src = qrDataUrl;
      });

      // Create texture from loaded image
      // Build the sprite
      const texture = Texture.from(image);
      const qrSprite = new Sprite(texture);

      // Stretch to match destination strictly as requested
      qrSprite.width = destination.width;
      qrSprite.height = destination.height;
      qrSprite.position.set(0, 0);

      container.addChild(qrSprite as unknown as ContainerChild);
    } catch (error) {
      console.error("Error generating QR code:", error);

      // Fallback to error message
      const errorText = new Text({
        text: "QR Error",
        style: {
          fontFamily: "Roboto",
          fontSize: 18,
          fill: "#ff0000",
          align: "center",
        },
      });

      errorText.anchor.set(0.5);
      errorText.position.set(destination.width / 2, destination.height / 2);
      container.addChild(errorText as unknown as ContainerChild);
    }
  }

  public destroy() {
    // No cleanup needed for QRWidgetRenderer
  }
}
